import '../../common/stylus/index.styl'

export default {
  install() {}
}



// WEBPACK FOOTER //
// ./node_modules/cube-ui/src/modules/style/index.js